import { render, staticRenderFns } from "./MeasurementPage.vue?vue&type=template&id=0715e5de&scoped=true&"
import script from "./MeasurementPage.vue?vue&type=script&lang=js&"
export * from "./MeasurementPage.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementPage.vue?vue&type=style&index=0&id=0715e5de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715e5de",
  null
  
)

export default component.exports